<!--
  九宫格游戏
 -->
<template>
  <div :class="['mymodal', `modal-${$setting.name}`, { animate: value && message.animate }]" :style="{ backgroundColor: message.bgColor }" v-show="value">
    <div class="info" :style="{ transform: this.message.animate ? 'scale(0)' : 'none' }">
      <div :class="['turntableMain', { animing: animing }]" :style="{ backgroundColor: `${configInfo.mainColour}80` }">
        <div class="prize-container">
          <div v-for="(item, index) in newPrizeList" :key="index" :class="['prize-item', 'prize-item-' + index]">
            <img class="img" :src="item.img" />
            <div class="name">{{ item.name }}</div>
          </div>
          <div ref="cover" :class="['cover', 'cover-' + index]" v-for="(item, index) in newPrizeList" :key="'over' + index"></div>
        </div>
        <div v-show="!downNext" class="turntabbtn" @click="handleStart">
          <div class="gameCount">还剩 {{ gameCount }} 次</div>
        </div>
        <div v-show="downNext" class="turntabbtn2">
          <div class="gameCount">还剩 {{ gameCount }} 次</div>
        </div>
      </div>
      <img class="close" @click="clickClose" src="http://assets.rurushishi.com/activies/activityCenter/turntableLottery/close.png" alt />
    </div>
  </div>
</template>

<script>
import { Toast, MessageBox } from "mint-ui";
import anime from "animejs";
import soundBuffer from "@/utils/sound";

export default {
  components: {},
  props: {},
  data() {
    return {
      value: false,
      callback: null,
      message: {},
      configInfo: null, //配置信息
      gameCount: 0,
      id: "",
      downNext: false,
      starting: false,
      animing: false,
      prizeInfo: {},
      thanks: [],
      soundBuf: null,
      prizeSoundBuf: null,
      thanksSoundBuf: null,
      btnBuf: null,
      prizeList: [],
    };
  },
  watch: {
    value: function (newVal) {
      if (newVal) {
        this.init();
      }
    },
    message: function (newVal, oldval) {
      console.log(newVal, oldval);
    },
  },
  filters: {
    filterName: function (name) {
      if (name == null) {
        return name + "***";
      } else if (name && name.length >= 1) {
        return name.slice(0, 2) + "***";
      } else {
        return name + "***";
      }
    },
  },
  computed: {
    newPrizeList() {
      this.thanks = [];
      let num = 8 - this.prizeList.length;
      let list = Array.from({ length: 8 }).fill(-1);
      while (num > 0) {
        let position = anime.random(0, 7);
        if (list[position] === -1) {
          this.thanks.push(position);
          list[position] = {
            name: "谢谢参与",
            code: "thanks",
            img: "https://assets.rurushishi.com/activies/activityCenter/jiugonggeLottery/thanks.png",
          };
          num--;
        }
      }
      let index = 0;
      for (let i = 0; i < list.length; i++) {
        if (list[i] === -1) {
          list[i] = this.prizeList[index];
          index++;
        }
      }
      return list;
    },
  },
  created() {
    this.configInfo = this.$configInfo;
    // preload mp3
    // next
    soundBuffer
      .getBuffer("https://assets.rurushishi.com/activies/activityCenter/zhuabaoxiangLottery/prize.mp3") // item.sound是音频线上地址
      .then((buf) => {
        this.prizeSoundBuf = buf;
      })
      .catch((e) => {
        console.log(e);
      });

    soundBuffer
      .getBuffer("https://assets.rurushishi.com/activies/activityCenter/zhuabaoxiangLottery/failed.mp3") // item.sound是音频线上地址
      .then((buf) => {
        this.thanksSoundBuf = buf;
      })
      .catch((e) => {
        console.log(e);
      });

    soundBuffer
      .getBuffer("https://assets.rurushishi.com/activies/activityCenter/jiugonggeLottery/starting.mp3") // item.sound是音频线上地址
      .then((buf) => {
        this.soundBuf = buf;
      })
      .catch((e) => {
        console.log(e);
      });
  },
  methods: {
    init() {
      this.id = this.message.item.id;
      this.gameCount = this.$util.cookie.get("gameCount");
      this.getPrizeList();
    },
    //关闭
    clickClose() {
      
      if (this.starting) {
        return;
      }
      this.value = false;
      this.callback(this.message.item.userLotteryCount);
    },
    // 获取点亮人数
    async getAccomplishLightCount() {
      let url = this.$apizt.action.accomplishLightCount;
      const { data, result } = await this.$httpzt.requestRestFul(url, {});
      if (result) {
        this.completedNum = data;
      }
    },
    showShare() {
      let text = {
        text1: "点击",
        text2: "右上角",
        text3: "推荐好友参与",
        text4: "让你和TA都获得金喜，",
        text5: "快去消息列表看看",
        text6: "会有什么神奇的事情发生吧！",
      };
      // if (this.configInfo.helpOnOrOff == 1) {
      //   text.text2 = `每日分享好友，最多获得${this.configInfo.helpTimesUpperLimit}次机会，`;
      //   let helpRule = JSON.parse(this.configInfo.helpRule);
      //   text.text3 = `每助力${helpRule.helpTimes}人，可获得${helpRule.getLotteryTimeWithHelp}次机会。`;
      // }
      this.clickClose();
      this.$modal.share.alert(text).then((data) => {
        if (data == "save") {
          console.log(this.configInfo.shareImg);
          this.$modal.poster.alert({
            gameBg: this.configInfo.shareImg, //分享截图背景图
          });
        }
      });
    },

    handleGameStatus() {
      return this.config.status == 3;
    },
    handleStart() {
      if (this.starting) {
        return;
      }
      if (this.gameCount <= 0) {
        this.showShare();
        return;
      }
      this.startGame();
    },
    async startGame() {
      this.starting = true;
      this.downNext = true;

      setTimeout(() => {
        this.downNext = false;
      }, 500);
      this.message.item.userLotteryCount++;
      this.gameCount -= 1;
      this.$util.cookie.set("gameCount", this.gameCount, {
        expires: 30,
      });
      let url = this.$apizt.action.assistanceLottery.api + `${this.id}`;
      const { data, code } = await this.$httpzt.requestRestFul(url, {}, "post");
      if (code == 8884 || code == 500) {
        this.prizeInfo = {
          code: "thanks",
        };
      }
      if (code == 200) {
        this.prizeInfo = {
          ...data,
        };
      }
      this.startGameAnimation(() => {
        // 根据奖品转动游戏
        this.starting = false;
        if (this.$configInfo.backgroundMusicSwitch && !this.$audio?.bg?.getIsPlay()) {
          if (this.prizeInfo.code == "thanks" && this.thanksSoundBuf) {
            const sound = soundBuffer.createSound(this.thanksSoundBuf);
            sound.start();
          } else if (this.prizeSoundBuf) {
            const sound = soundBuffer.createSound(this.prizeSoundBuf);
            sound.start();
          }
        }
        this.$modal.form
          .alert({
            type: this.prizeInfo.code == "thanks" ? "thanks" : "key",
            code: this.prizeInfo.prizeCode,
            prizeName: this.prizeInfo.name,
            receiveKey: this.prizeInfo.receiveKey,
            prizeType: this.prizeInfo.prizeType,
            deadline: this.prizeInfo.deadline,
            category: 1,
            share: false,
            animate: true,
          })
          .then((res) => {
            console.log("form callback");
            if (this.gameCount <= 0) {
              this.showShare();
            }
            // this.value = false;
          });
      });
    },
    startGameAnimation(callback) {
      let that = this;
      let len = this.newPrizeList.length;
      this.animing = true;
      // 查找中奖第几个
      let index = 0;
      if (this.prizeInfo.code == "thanks" || this.prizeInfo.prizeCode == "thanks") {
        index = this.thanks[anime.random(0, this.thanks.length - 1)];
      } else {
        index = this.newPrizeList.findIndex((x) => x.code == this.prizeInfo.prizeCode);
      }
      console.log("prizeInfo:", index);
      this.prizeInfo = { ...this.newPrizeList[index], ...this.prizeInfo };
      let total = len * 3 + index;
      let end = anime.random(4, 7);
      let box = {
        value: 0,
      };
      let preIndex = -1;
      let tl = anime.timeline({
        targets: box,
        easing: "linear",
        round: 1,
      });
      // let soundIndex = 0;
      // let playSound = () => {
      //   that.$refs.startingMusic[soundIndex].play();
      //   setTimeout(() => {
      //     if (soundIndex >= 0) {
      //       that.$refs.startingMusic[soundIndex].pause();
      //       that.$refs.startingMusic[soundIndex].currentTime = 0;
      //       soundIndex = soundIndex == 0 ? 1 : 0;
      //       playSound();
      //     }
      //   }, 200);
      // };
      // playSound();
      let loop = true;
      if (this.soundBuf && this.$configInfo.backgroundMusicSwitch && !this.$audio?.bg?.getIsPlay()) {
        that.sound = soundBuffer.createSound(this.soundBuf);
        that.sound.loop = loop;
        that.sound.start();
      }
      tl.add({
        value: total - end,
        duration: 2000,
        update() {
          let activeIndex = box.value % len;
          if (activeIndex != preIndex) {
            preIndex = activeIndex;
            console.log(activeIndex);
            if (that.soundBuf && loop == false && that.$configInfo.backgroundMusicSwitch && !that.$audio?.bg?.getIsPlay()) {
              that.sound = soundBuffer.createSound(that.soundBuf);
              that.sound.start();
            }
            // if (soundIndex == -1) {
            //   that.$refs.startingMusic[activeIndex % 2].play();
            // }
            if (that.$refs.cover[activeIndex]) {
              that.$refs.cover[activeIndex].style.display = "none";
              that.$refs.cover[activeIndex == 0 ? 7 : activeIndex - 1].style.display = "block";
            }
            // console.log(activeIndex);
            // prizeList[activeIndex].classList.add("active");
            // prizeList[activeIndex == 0 ? 7 : activeIndex - 1].classList.remove("active");
          }
        },
        complete() {
          if (that.soundBuf && that.$configInfo.backgroundMusicSwitch && !that.$audio?.bg?.getIsPlay()) {
            that.sound.loop = false;
            loop = false;
          }
        },
      }).add({
        duration: 1000,
        value: total,
        complete() {
          // that.$refs.startingMusic.pause();
          setTimeout(() => {
            that.animing = false;
            that.$refs.cover.forEach((x) => {
              x.style.display = "";
            });
            if (that.$refs.cover.length != 0) {
              callback();
            }
          }, 500);
        },
      });
    },

    async getPrizeList() {
      let url = this.$apizt.action.getLotteryPrize;
      const { result, data } = await this.$httpzt.requestRestFul(url, {size:'7',siteId:this.id}, "get");
      if (result) {
        this.prizeList = data;
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
@keyframes modal_animate {
  0 {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;

  &.animate {
    .info {
      animation-name: modal_animate;
    }
  }

  .info {
    position: relative;
    width: 321px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    animation-timing-function: ease-out;
    animation-duration: 1s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    transform: scale(0);

    .close {
      position: relative;
      width: 40px;
      height: 40px;
      z-index: 1002;
      margin-top: 28px;
    }
  }
}
</style>

<style lang="scss" scoped>
.turntableMain {
  width: 321px;
  height: 321px;
  overflow-x: hidden;
  position: relative;
  border-radius: 12px;
  margin: 40px auto 0;

  &.animing {
    .prize-container {
      .cover {
        display: block;
      }
    }
    .turntabbtn {
      opacity: 0.6;
    }
  }

  .prize-container {
    width: 295px;
    height: 295px;
    position: absolute;
    left: 14px;
    top: 14px;
    background: rgba(4, 2, 0, 0.4);
    border-radius: 8px;
    .cover {
      background: rgba(0, 0, 0, 0.2);
      width: 90px;
      height: 90px;
      position: absolute;
      display: none;
    }
    .prize-item {
      width: 90px;
      height: 90px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      background-size: 90px 90px;
      background-position: center center;
      background-repeat: no-repeat;
      background-image: url("https://assets.rurushishi.com/activies/activityCenter/jiugonggeLottery/lotteryPointer.png");

      .img {
        width: 50px;
        height: 50px;
        object-fit: cover;
      }
      .name {
        color: #b35739;
        max-width: 100%;
        padding-top: 6px;
        padding-bottom: 6px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
      }
    }
    .prize-item-0,
    .cover-0 {
      top: 6px;
      left: 6px;
    }
    .prize-item-1,
    .cover-1 {
      top: 6px;
      left: 102px;
    }
    .prize-item-2,
    .cover-2 {
      top: 6px;
      left: 198px;
    }
    .prize-item-3,
    .cover-3 {
      top: 102px;
      left: 198px;
    }
    .prize-item-4,
    .cover-4 {
      top: 198px;
      left: 198px;
    }
    .prize-item-5,
    .cover-5 {
      top: 198px;
      left: 102px;
    }
    .prize-item-6,
    .cover-6 {
      top: 198px;
      left: 6px;
    }
    .prize-item-7,
    .cover-7 {
      top: 102px;
      left: 6px;
    }
  }
  .turntabbtn {
    width: 90px;
    height: 90px;
    background-size: 100% auto;
    position: absolute;
    top: 116px;
    left: 116px;
    background-image: url("https://assets.rurushishi.com/activies/activityCenter/jiugonggeLottery/draw.png");
  }
  .turntabbtn2 {
    width: 90px;
    height: 90px;
    background-size: 100% auto;
    position: absolute;
    top: 116px;
    left: 116px;
    background-image: url("https://assets.rurushishi.com/activies/activityCenter/jiugonggeLottery/draw2.png");
  }
  .gameCount {
    width: 72px;
    text-align: center;
    color: #a8422d;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    transform: scale(0.8);
    margin-top: 59px;
    margin-left: 10px;
  }
  .rollWins {
    position: absolute;
    width: 240px;
    bottom: 28px;
    left: 66px;
    background: linear-gradient(180deg, #4b1835 0%, #610b44 97.92%);
    border-radius: 8px;
  }
}
</style>
